import _classCallCheck from "/home/node/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/node/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/node/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Factory } from '../Factory.js';
import { Shape } from '../Shape.js';
import { getNumberValidator } from '../Validators.js';
import { _registerNode } from '../Global.js';
var PIx2 = Math.PI * 2;
export var Ring = /*#__PURE__*/function (_Shape) {
  _inherits(Ring, _Shape);
  var _super = _createSuper(Ring);
  function Ring() {
    _classCallCheck(this, Ring);
    return _super.apply(this, arguments);
  }
  _createClass(Ring, [{
    key: "_sceneFunc",
    value: function _sceneFunc(context) {
      context.beginPath();
      context.arc(0, 0, this.innerRadius(), 0, PIx2, false);
      context.moveTo(this.outerRadius(), 0);
      context.arc(0, 0, this.outerRadius(), PIx2, 0, true);
      context.closePath();
      context.fillStrokeShape(this);
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.outerRadius() * 2;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.outerRadius() * 2;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      this.outerRadius(width / 2);
    }
  }, {
    key: "setHeight",
    value: function setHeight(height) {
      this.outerRadius(height / 2);
    }
  }]);
  return Ring;
}(Shape);
Ring.prototype.className = 'Ring';
Ring.prototype._centroid = true;
Ring.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
_registerNode(Ring);
Factory.addGetterSetter(Ring, 'innerRadius', 0, getNumberValidator());
Factory.addGetterSetter(Ring, 'outerRadius', 0, getNumberValidator());